"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateAdminRolePermissionDto = instanceOfUpdateAdminRolePermissionDto;
exports.UpdateAdminRolePermissionDtoFromJSON = UpdateAdminRolePermissionDtoFromJSON;
exports.UpdateAdminRolePermissionDtoFromJSONTyped = UpdateAdminRolePermissionDtoFromJSONTyped;
exports.UpdateAdminRolePermissionDtoToJSON = UpdateAdminRolePermissionDtoToJSON;
exports.UpdateAdminRolePermissionDtoToJSONTyped = UpdateAdminRolePermissionDtoToJSONTyped;
/**
 * Check if a given object implements the UpdateAdminRolePermissionDto interface.
 */
function instanceOfUpdateAdminRolePermissionDto(value) {
    if (!('permissionId' in value) || value['permissionId'] === undefined)
        return false;
    if (!('allocated' in value) || value['allocated'] === undefined)
        return false;
    return true;
}
function UpdateAdminRolePermissionDtoFromJSON(json) {
    return UpdateAdminRolePermissionDtoFromJSONTyped(json, false);
}
function UpdateAdminRolePermissionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'permissionId': json['permissionId'],
        'allocated': json['allocated'],
    };
}
function UpdateAdminRolePermissionDtoToJSON(json) {
    return UpdateAdminRolePermissionDtoToJSONTyped(json, false);
}
function UpdateAdminRolePermissionDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'permissionId': value['permissionId'],
        'allocated': value['allocated'],
    };
}
